"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const cn_1 = require("src/misc/cn");
const UltraIcon_1 = require("src/icons/UltraIcon");
const TransactionFee = ({ gasFee, gasless }) => {
    if (!gasFee)
        return null;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center justify-between text-xs", children: [(0, jsx_runtime_1.jsx)("div", { className: "flex w-[50%] text-primary-text/50", children: (0, jsx_runtime_1.jsx)("span", { children: "Network Fee" }) }), (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-1", children: [gasless && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(UltraIcon_1.UltraIcon, { color: "#FDB022", width: 12, height: 12 }), (0, jsx_runtime_1.jsx)("div", { className: "text-xs text-primary-text", children: "Gasless" })] })), (0, jsx_runtime_1.jsxs)("div", { className: (0, cn_1.cn)('text-primary-text', {
                            'line-through': gasless,
                        }), children: [gasFee, " SOL"] })] })] }));
};
exports.default = TransactionFee;
